export enum ProfileLookupBehaviorEnum {
  Default, //
  AuthenticatedProfile,
  RelatedOrgMember,
  RelatedIndMember,
}
